export default {
    calendar: {
        create: {
            task: 'Set a task',
            sotrmeet_title: 'Plan an event',
            task_title: 'Set a task',
            startTime: 'Start time',
            endTime: 'End Time',
            event: 'Event',
            priority: 'Priority',
            done: 'Done',
            alarm: 'Warn'
        },
        edit_task: 'Edit task',
        edit_sotrmeet: 'Edit event',
        description: 'Description',
        show_in_planner: 'Show in the planner',
        own_event: 'Private event',
        time: 'Time',
        date: 'Date',
        date_from: 'Date from',
        date_to: 'Date to',
        today: 'Today',
        day: 'Day',
        week7: 'Week 7',
        week5: 'Week 5',
        events: 'Events',
        tasks: 'Tasks',
        personal: 'Personal',
        conversations: 'Conversations',
        meetings: 'Meetings',
        planner: 'Planner',
        education: 'Education',
        no_events: 'No events',
        no_tasks: 'No tasks',
        filtersNotSelected: 'No selected filters',
        show_completed_tasks: 'Show completed tasks',
        whole_day: 'whole day',
        education_event: 'Education event',
        no_education_events: 'No education events',
        task_list_headers: {
            date: 'Date',
            description: 'Description',
            priority: 'Priority',
            done: 'Done'
        },
        education_events_fields: {
            name: 'Name',
            project: 'Project',
            people: 'Contact',
            date: 'Date of event',
            time: 'Time of event',
            place: 'Place',
            trainers: 'Trainer list'
        }
    }
};
